'use strict';

/**
 * Подключение библиотеки jQuery
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

import $ from 'jquery';

// ----------------------------------------
// Public
// ----------------------------------------

window.$ = window.jQuery = $;



// WEBPACK FOOTER //
// ./_HTML/src/js/_vendors/jquery.js